import React from 'react';
import { CreditCard, GraduationCap } from 'lucide-react';

const EmiScholarship = ({ onApply }) => {
  return (
    <section className="emi-scholarship-section">
      <div className="emi-container">
        <div className="emi-header-row">
          <h2 className="section-title">Easy EMI & <span>Scholarships</span></h2>
          <button className="btn-primary" onClick={onApply}>
            Apply Now
          </button>
        </div>

        <div className="scholarship-cards-grid">
          <div className="scholarship-card">
            <div className="card-icon-wrap">
              <CreditCard size={36} color="#FF6B00" />
            </div>
            <div className="card-content">
              <h3>Avail Easy Financing Options</h3>
              <p>
                With our no-cost EMIs, we let your learning take the spotlight without the stress of upfront financing.
              </p>
            </div>
          </div>

          <div className="scholarship-card">
            <div className="card-icon-wrap">
              <GraduationCap size={36} color="#FF6B00" />
            </div>
            <div className="card-content">
              <h3>Get Attractive Scholarships</h3>
              <p>
                Exclusive scholarships designed for defense personnel, government employees, differently-abled individuals & meritorious students.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default EmiScholarship;
